import { object } from "yup"
import { confirmPassword, password } from "@/core/validation"

export default object({
  currentPassword: password,
  password,
  confirmNewPassword: confirmPassword,
})
